export const getCPSStyles = () => ({
  cpsOptions: {
    '& .alert-container': {
      marginTop: 8,
    },
  },
});
